module.exports = __webpack_public_path__ + "assets/icons/my-bids.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/my-bids.png
// module id = ./src/styles/icons/sidemenu/my-bids.png
// module chunks = 0